import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import TournamentsView from "../../../tournaments/TournamentsView.tsx";

export const Route = createFileRoute('/_app/tournaments/$tournament_uid')({
  component: RouteComponent,
})

function RouteComponent() {
  return <TournamentsView />
}
